import React, { createRef } from "react";
import {
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip as Tooltip2,
} from "antd";
import L from "leaflet";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import config from "../config";
import withRouter from "../withRouter";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import MapForVehiclePosition from "./MapForVehiclePosition";

import GeofenceReportStore from "../store/GeofenceReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import {
  MapContainer,
  Tooltip,
  Marker,
  Popup,
  Circle,
  Polygon,
  Rectangle,
} from "react-leaflet";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import AdditionalContentInMap from "./AdditionalContentInMap";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
// import conf from "../config";
import { Icon } from "leaflet";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import XML from "../assets/images/NewDesign/XML.svg";
import CSV from "../assets/images/NewDesign/CSV.svg";
import PythonMessageAlert from "./PythonMessageAlert";
import conf from "../config";

const dotIcon = new Icon({
  iconUrl: require("../assets/images/location-pin.png"),
  iconSize: [38, 38], // size of the icon
});

// const dotIcon2 = L.divIcon({
//   className: "dot-icon",
//   iconSize: [8, 8],
//   html: ' <div style="width: 20px; height: 20px; background-color: red; border-radius: 50%;"></div>',
// });
const { RangePicker } = DatePicker;
const { Option } = Select;
class GeofenceReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.geofencePOIReportStore = new GeofenceReportStore();
    this.vehicleStore = new VehicleStore();
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyId: "",
      selectedVehicles: [],
      selectedgeofenceData: [],
      selectAllGeofenceData: false,
      markers: [],
      modalVisible: false,
      column: "",
      filter: "",
      selectAllVehicles: false,
      allGeo: 0,
      showMap: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      showMonthPopup: false,
      mandatory: false,
      company: false,
      asset: false,
      Notdate: false,
      vehicle: false,
      // array:[0,0,0],
      vehicleObj: false,

      addressInfo: this.props.addressInfo,
      update: 0,
      type: "",
      key: new Date(),
      traffic: false,
      flag: true,
      mapBtn: false,
      satelliteBtn: false,
      modalInfoObj: [],
      reportmessage: "",
      selectedColumns: [
        {
          // title: " Vehicle No ",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          // fixed: 'left',
          width: "15%",
          key: "vehicleNo",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "  Driver",
          title: context.translate("_FLEET_MANAGEVEHICLE_DRIVER_TAB_"),
          dataIndex: "name",
          width: "15%",
          key: "name",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: " In Time ",
          title: context.translate("_FLEET_REPORTS_GEOFENCEREPORT_INTIME_"),
          dataIndex: "inTime",
          //fixed: 'left',
          width: "15%",
          key: "inTime",
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          },
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_GEOFENCEREPORT_LOCATION_IN_"
          ),
          dataIndex: "locationIn",
          ellipsis: true,
          width: "15%",
          key: "locationIn",
          ellipsis: {
            showTitle: true,
          },
          render: (value, obj) => {
            // console.log(obj)
            return (
              <Link
                onClick={async (e) => {
                  await this.setState({ modalInfoObj: obj });
                  await this.setState({
                    vehicleObj: {
                      ...obj,
                      icon: "logo_icon.png",
                      latitude: obj.latitudeIn,
                      longitude: obj.longitudeIn,
                    },
                    heading: this.context.translate("_LOCATION_ON_MAP_"),
                  });
                  console.log(this.state.vehicleObj);
                  await this.setState({ loadData: 1 });
                }}
              >
                {value}
              </Link>
            );
          },
        },

        {
          // title: " Out Time ",
          title: context.translate("_FLEET_REPORTS_GEOFENCEREPORT_OUTTIME_"),
          dataIndex: "outTime",
          //fixed: 'left',
          width: "15%",
          key: "outTime",
          ellipsis: {
            showTitle: true,
          },
          render: (value) => {
            if (value === null) {
              return "";
            } else {
              const formattedDateTime = dayjs(value).format(
                "DD-MM-YYYY hh:mm:ss A"
              );
              return <>{formattedDateTime}</>;
            }
          },
        },
        {
          title: context.translate(
            "_FLEET_REPORTS_GEOFENCEREPORT_LOCATION_OUT_"
          ),
          dataIndex: "locationOut",
          width: "15%",
          key: "name",
          ellipsis: {
            showTitle: true,
          },
          render: (value, obj) => {
            return (
              <Link
                onClick={async (e) => {
                  // await this.setState({ showMap: true, modalInfoObj: obj });
                  await this.setState({
                    vehicleObj: {
                      ...obj,
                      icon: "logo_icon.png",
                      latitude: obj.latitudeOut,
                      longitude: obj.longitudeOut,
                    },
                    heading: this.context.translate("_LOCATION_ON_MAP_"),
                  });
                  console.log(this.state.vehicleObj);
                  await this.setState({ loadData: 1 });
                }}
              >
                {value}
              </Link>
            );
          },
        },
        {
          // title: "Type",
          title: context.translate("_FLEET_DASHBORD_NEWPOI_TYPE_"),
          dataIndex: "typeName",
          width: "15%",
          key: "typeName",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: "  Geofence or POI ",
          title: context.translate("_FLEET_REPORTS_GEOFENCEREPORT_GEOPOI_"),
          dataIndex: "geoname",
          width: "15%",
          key: "geoname",
          ellipsis: {
            showTitle: true,
          },
        },
        {
          // title: " Elapsed Time Inside The Geofence ",
          title: context.translate("_FLEET_REPORTS_GEOFENCEREPORT_ELAPSETIME_"),
          dataIndex: "elapsedTime",
          width: "15%",
          ellipsis: {
            showTitle: true,
          },
          key: "elapsedTime",
        },
        {
          // title: "  Driver",
          title: context.translate("_MAX_SPEED_1"),
          dataIndex: "maxSpeed",
          width: "15%",
          key: "maxSpeed",
          ellipsis: {
            showTitle: true,
          },
        },

        {
          // title: "View On Map",
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          dataIndex: "",
          // fixed: 'right',
          width: "15%",
          key: "View",
          ellipsis: {
            showTitle: true,
          },
          render: (value, obj) => {
            return (
              <>
                <Link onClick={(e) => this.handleGeofenceFunc(obj)}>
                  {" "}
                  <img
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    width={25}
                    height={25}
                  />
                </Link>
              </>
            );
          },
        },
      ],
    };
    if (conf.project === "proawtltrack") {
  this.state.selectedColumns = this.state.selectedColumns.filter(
    (col) => 
      col.dataIndex !== "maxSpeed" && 
      col.dataIndex !== "locationIn" && 
      col.dataIndex !== "locationOut"
  );
};

      //  console.log("abhishek")
    
    this.mapRef = React.createRef();
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          //  console.log(result.toString())

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles.map(Number),
            intervel: this.state.intervel,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            userId: 1,
            filter: this.state.filter,
            geoZoneId: this.state.selectedgeofenceData.map(Number),
            colList: result.toString(),
            allGeo: this.state.allGeo,
          };
          if (val.key === "excel") {
            // console.log("afd")
            await this.geofencePOIReportStore.exportExcel(getData);
            const isSuccess =
              this.geofencePOIReportStore?.pythonReportMessage === true;
            const isError =
              this.geofencePOIReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key === "pdf") {
            await this.geofencePOIReportStore.exportpdf(getData);
            const isSuccess =
              this.geofencePOIReportStore?.pythonReportMessage === true;
            const isError =
              this.geofencePOIReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          // if (val.key == "csv") {
          //   this.geofencePOIReportStore.exportcsv(getData);
          // }
          // if (val.key == "xml") {
          //   this.geofencePOIReportStore.exportxml(getData);
          // }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }
  extractMarkers(obj) {
    console.log(obj);
    const markers = [];

    if (obj.latitudeIn && obj.longitudeIn) {
      markers.push({
        lat: parseFloat(obj.latitudeIn),
        lng: parseFloat(obj.longitudeIn),
        name: "In",
      });
    }

    if (obj.latitudeOut && obj.longitudeOut) {
      markers.push({
        lat: parseFloat(obj.latitudeOut),
        lng: parseFloat(obj.longitudeOut),
        name: "Out",
      });
    }

    return markers;
  }

  handleGeofenceFunc = async (obj) => {
  await this.setState({ showMap: true, modalInfoObj: obj });

  const rawPoints = obj.points.split(",").map(Number);
  const markers = this.extractMarkers(obj);

  const map = this.mapRef.current;
  if (!map) return;

  let geofenceShape = null;
  let bounds = L.latLngBounds();

  // 🔵 CIRCLE (lat,lng)
  if (rawPoints.length === 2) {
    const [lat, lng] = rawPoints;
    const radius = obj.radius || 5;

    geofenceShape = {
      type: "circle",
      data: { lat, lng, radius },
    };

    bounds = L.latLng(lat, lng).toBounds(radius * 2);
  }

  // 🔺 POLYGON (lat,lng,...)
  else if (rawPoints.length >= 6) {
    const polygon = [];

    for (let i = 0; i < rawPoints.length; i += 3) {
      polygon.push([rawPoints[i], rawPoints[i + 1]]);
    }

    geofenceShape = {
      type: "polygon",
      data: polygon,
    };

    bounds = L.latLngBounds(polygon);
  }

  // ➕ include markers in bounds
  markers.forEach((m) => {
    bounds.extend([m.lat, m.lng]);
  });

  // 🚀 fit map
  if (bounds.isValid()) {
    map.fitBounds(bounds, {
      padding: [50, 50],
      maxZoom: 13,
    });
  }

  await this.setState({ geofenceShape, markers });
};

  // handleGeofenceFunc = async (obj) => {
  //   await this.setState({ showMap: true, modalInfoObj: obj });

  //   // POLYGON POINTS
  //   const rawPoints = obj.points.split(",").map(Number);
  //   const polygon = [];

  //   for (let i = 0; i < rawPoints.length; i += 3) {
  //     polygon.push([rawPoints[i], rawPoints[i + 1]]);
  //   }

  //   // MARKERS
  //   const markers = this.extractMarkers(obj);
  //   await this.setState({ markers });

  //   // MAP INSTANCE
  //   const map = this.mapRef.current;
  //   if (!map) return;

  //   // --- BOUNDS COLLECTION ---
  //   const allBounds = [];

  //   // polygon bounds
  //   if (polygon.length > 2) {
  //     polygon.forEach((p) => allBounds.push(p));
  //   }

  //   // marker bounds
  //   if (markers.length > 0) {
  //     markers.forEach((m) => allBounds.push([m.lat, m.lng]));
  //   }

  //   // --- APPLY BOUNDS ---
  //   if (allBounds.length > 0) {
  //     const bounds = L.latLngBounds(allBounds);

  //     map.fitBounds(bounds, {
  //       padding: [50, 50],
  //       maxZoom: 13, // force zoom OUT (lower = more zoomed out)
  //     });
  //   }

  //   await this.setState({ polygon });
  // };

  handleGeofenceFuncold = async (obj) => {
    console.log(obj);
    await this.setState({ showMap: true, modalInfoObj: obj });
    console.log(parseFloat(this.state.modalInfoObj?.points?.split(",")[0]));
    let latlongs = [
      parseFloat(this.state.modalInfoObj?.points?.split(",")[0]),
      parseFloat(this.state.modalInfoObj?.points?.split(",")[1]),
    ];

    // const markers2 = [
    //   { lat: 25.178024421461,  lng: 55.390588312238, name: 'San Francisco' },
    //   { lat: 25.17899421461,  lng: 55.390588312238, name: 'Los Angeles' },
    //  ];
    // console.log("marker1",markers2)
    var markers = [];
    if (
      this.state.modalInfoObj?.latitudeIn &&
      this.state.modalInfoObj?.latitudeOut
    ) {
      markers = [
        {
          lat: parseFloat(this.state.modalInfoObj?.latitudeIn),
          lng: parseFloat(this.state.modalInfoObj?.longitudeIn),
          name: "In",
        },
        {
          lat: parseFloat(this.state.modalInfoObj?.latitudeOut),
          lng: parseFloat(this.state.modalInfoObj?.longitudeOut),
          name: "Out",
        },
      ];
    } else {
      markers = [
        {
          lat: parseFloat(this.state.modalInfoObj?.latitudeIn),
          lng: parseFloat(this.state.modalInfoObj?.longitudeIn),
          name: "In",
        },
      ];
    }

    console.log("markers", markers);
    await this.setState({ markers: markers });
    if (Number(obj.radius) > 1000) {
      await this.mapRef.current.fitBounds([latlongs], { maxZoom: 12 });
    } else if (Number(obj.radius) < 400) {
      await this.mapRef.current.fitBounds([latlongs], { maxZoom: 17 });
    } else {
      await this.mapRef.current.fitBounds([latlongs], { maxZoom: 15 });
    }
    console.log(latlongs);
    // await this.mapRef.current.setView(latlongs,13)
  };

  async componentDidMount() {
    // await this.geofencePOIReportStore.loadData({ offset: 0, limit: 50 });
    await this.setState({ column: this.state.selectedColumns });
    console.log("hello");
    this.setState({ pageSize: 20 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      console.log("ilocasd");
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1);
    if (this.state.showMap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 10);
    }
  }

  async handleChange(comp) {
    this.setState({ company: false });
    this.setState({ selectedVehicles: [], selectAllVehicles: false });
    this.setState({ selectedgeofenceData: [], selectAllGeofenceData: false });
    await this.setState({ companyId: comp?.value });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.geofencePOIReportStore.getGeofenceDataByCompany({
      companyId: comp?.value,
    });

    await this.handleSearch();
    // console.log(data, "sfdgdsfghfh");

    // console.log("data", data);
  }

  async handleSearch() {
    // this.setState({ loading: true });
    // await this.geofencePOIReportStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    // });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }

  vehicleSelect = async (val) => {
    console.log(val);
    await this.setState({ selectedVehicles: val });
  };

  showData = async () => {
    // console.log("click");
    // console.log(this.state.selectedgeofenceData.length, this.state.companyId);
    if (!this.state.companyId) {
      this.setState({ company: true });
    } else {
      this.setState({ company: false });
    }
    if (this.state.selectedgeofenceData.length === 0) {
      this.setState({ vehicle: true });
    } else {
      this.setState({ vehicle: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ asset: true });
    } else {
      this.setState({ asset: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }

    if (
      this.state.companyId &&
      this.state.selectedgeofenceData.length > 0 &&
      this.state.selectedVehicles.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      // this.setState({mandatory:false})
      this.setState({ company: false, asset: false, vehicle: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.geofencePOIReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          geoZoneId: this.state.selectedgeofenceData.map(Number),
          // geoZoneId: this.state.selectedgeofenceData,
        });
        this.setState({ loadData: 1 });
      }
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleSelectAllGeofenceData = async (e) => {
    if (this.state.selectAllGeofenceData) {
      const allGeofenceData = this.geofencePOIReportStore?.geofenceData.map(
        (val) => {
          return val.zoneId;
        }
      );
      await this.setState({ selectedgeofenceData: allGeofenceData });
    } else {
      await this.setState({ selectedgeofenceData: [] });
    }
  };

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };

  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  handleBtnFunc = (state) => {
    this.setState({ [state]: true });
    setTimeout(() => {
      this.setState({ [state]: false });
    }, 1000);
  };
  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  render() {
    const companyInputStyle = this.state.company
      ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    const assetInputStyle = this.state.asset
      ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    const vehicleInputStyle = this.state.vehicle
      ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };

    const mapData = this.state.modalInfoObj.points?.split(",0,").map((val) => {
      return val.split(",").map((val) => Number(val));
    });
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_FLEET_REPORTS_GEOFENCEREPORT_TITLE_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
              

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.geofencePOIReportStore?.geofenceReportStore?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button className="exportDropdown"
                  // style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={inputStyle}
                  // style={companyInputStyle}
                  status={this.state.company ? "error" : false}
                  // style={this.state.array[0] ? { border: '1px solid red',width: 160,borderRadius: 8 } : { width: 160}}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                    });
                    console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}

                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    if (val?.length > 1) {
                      console.log(val?.length > 1);
                      this.setState({ showAlertPopup: true });
                    }
                  }}
                  style={{ width: 200 }}
                  showSearch
                  status={this.state.asset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>
                <Checkbox
                  checked={this.state.selectAllGeofenceData}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllGeofenceData: e.target.checked,
                    });
                    console.log(e.target.checked);
                    await this.handleSelectAllGeofenceData();
                  }}
                />
                {/* All */}
                {this.context.translate("_ALL_")}
                <Select
                  className="searchInput"
                  mode="multiple"
                  onSearch={this.handleSearch}
                  maxTagCount="responsive"
                  value={this.state.selectedgeofenceData}
                  onChange={(val) => {
                    this.setState({
                      selectedgeofenceData: val,
                      vehicle: false,
                    });
                    if (
                      this.geofencePOIReportStore?.geofenceData.length >
                      val.length
                    ) {
                      this.setState({
                        selectAllGeofenceData: false,
                        allGeo: 1,
                      });
                    } else {
                      this.setState({ selectAllGeofenceData: true, allGeo: 0 });
                    }
                  }}
                  // fieldNames={{ label: "name", value: "zoneId" }}
                  // placeholder=" Geofence"
                  placeholder={this.context.translate("_GEOFENCE_")}
                  optionFilterProp="children"
                  // options={this.geofencePOIReportStore?.geofenceData}
                  style={{ width: 150 }}
                  status={this.state.vehicle ? "error" : false}
                  showSearch
                  // style={inputStyle}
                  // style={vehicleInputStyle}
                  // style={this.state.array[2] ? { border: '1px solid red',width: 160,borderRadius: 8 } : { width: 160}}
                  onSelect={(val) => console.log(val)}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.geofencePOIReportStore?.geofenceData?.map((val) => {
                    return <Option value={val.zoneId}>{val.name}</Option>;
                  })}
                </Select>
                <RangePicker
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ],
                  }}
                  status={this.state.Notdate ? "error" : false}
                  defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                />

                <Button type="primary" onClick={() => this.showData()}>
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip2
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  {" "}
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip2>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.geofencePOIReportStore?.geofenceReportStore?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.geofencePOIReportStore?.total}
            columns={this.state.selectedColumns}
            dataSource={this.geofencePOIReportStore?.geofenceReportStore}
            loading={this.geofencePOIReportStore?.loading}
            onChange={this.handleTableChange}
            // showSizeChanger={false}
            // moreClass="gridNum"
            {...(conf.currentFlavor === "nodeui" && {
              showSizeChanger: false,
              moreClass: "gridNum",
            })}

            // pagination={{
            //   pageSize: this.state.pageSize,
            //   total: this.geofencePOIReportStore.total || 0,
            // }}
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />

          {this.state.showMap && (
            <Modal
              className="multiTracking-popup"
              style={{ padding: "0px !important" }}
              title={
                <div>
                  Geofence or POI In Out Report on Map
                  <CloseOutlined
                    onClick={() => this.setState({ showMap: false })}
                  />
                </div>
              }
              maskClosable={false}
              open={this.state.showMap}
              centered
              // bodyStyle={{ height: 1000 }}
              width={1000}
              bodyStyle={{ height: "60vh", padding: "0px" }}
              onOk={() => this.setState({ showMap: false })}
              onCancel={() => this.setState({ showMap: false })}
              footer={false}
            >
              <div
                dir={this.context.locale.language === "arabic" ? "ltr" : "ltr"}
              >
                <MapContainer
                  ref={this.mapRef}
                  zoom={12}
                  center={[
                    parseFloat(this.state.modalInfoObj?.points?.split(",")[0]),
                    parseFloat(this.state.modalInfoObj?.points?.split(",")[1]),
                  ]}
                  // center={config.center}
                  style={{ height: "60vh", position: "relative" }}
                >
                  <ReactLeafletGoogleLayer />

                  {/* {this.state.polygon?.length > 2 && (
                    <Polygon
                      positions={this.state.polygon}
                      pathOptions={{ color: "red" }}
                    />
                  )} */}
                  {this.state.geofenceShape?.type === "polygon" && (
                    <Polygon
                      positions={this.state.geofenceShape.data}
                      pathOptions={{ color: "red" }}
                    />
                  )}

                  {this.state.geofenceShape?.type === "circle" && (
                    <Circle
                      center={[
                        this.state.geofenceShape.data.lat,
                        this.state.geofenceShape.data.lng,
                      ]}
                      radius={this.state.geofenceShape.data.radius}
                      pathOptions={{ color: "red", fillOpacity: 0.3 }}
                    />
                  )}

                  {/* {this.state.markers?.map((marker, idx) => (
                    // console.log("position",marker.lat,marker.lng)
                    <Marker position={[marker.lat, marker.lng]} icon={dotIcon}>
                      <Tooltip permanent direction="top" offset={[1, -10]}>
                        <b>{marker.name}</b>
                      </Tooltip>
                    </Marker>
                  ))} */}
                  {this.state.markers?.map((m, i) => (
                    <Marker key={i} position={[m.lat, m.lng]} icon={dotIcon}>
                      <Tooltip permanent>{m.name}</Tooltip>
                    </Marker>
                  ))}

                  <AdditionalContentInMap size="small" This={this} />
                </MapContainer>
              </div>
            </Modal>
          )}

          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {/* Alert */}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {/* For Reports prior to 6 months please contact administrator */}
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>
        </div>
        {this.state.vehicleObj && (
          <MapForVehiclePosition
            vehicleObj={this.state.vehicleObj}
            heading={this.state.heading}
            closeMapModal={(resp) => {
              this.setState({ vehicleObj: resp });
            }}
          />
        )}
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
GeofenceReportList.contextType = StoreContext;
export default observer(withRouter(GeofenceReportList));
